/**
 * The default site we spoof oursleves as in tenantless development environments.
 */
export const DEVELOPMENT_ORIGIN = new URL('https://fabric-development.jira-dev.com');

/**
 * A list of tenantless developoment environments. No 'site' exists for these formally,
 * requiring the use of @see {@link DEVELOPMENT_ORIGIN} as a spoofed origin.
 */
export const DEVELOPMENT_TENANTLESS_HOSTNAMES = ['localhost', 'canvas.dev.atlassian.com'];
